import * as React from 'react'
import { observer } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import { Button } from 'react-bootstrap'
import { history } from '../../../../Routing'

@observer
export default class ExternalDataSearchView extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    ls = LocalizationStore.getInstance()

    schema: Object = {
        'type': 'object',
        'properties': {
            'phone': {
                'title': this.ls.t('Enter phone number'),
                'type': 'string'
            }
        }
    }
    
    submit(e: ISubmitEvent<any>) {
        // history.push('/externalData/searchByPhone/' + e.formData['phone'])
        history.push('/externalData/' + e.formData['phone'])
    }

    render() {
        const self = this
        let ls = LocalizationStore.getInstance()

        return (
            <div className="searchBlock">
                <Form
                    onSubmit={this.submit}
                    schema={self.schema}
                >
                    <div className="searchBtn">
                        <Button type="submit">{ls.t!('SearchBtn')}</Button>
                    </div>  
                </Form>
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByPhoneView.tsx